import axios from "axios"
import Vue from 'vue'

Vue.mixin({
    methods: {
        capitalizeFirstLetter(str) {
            return str.charAt(0).toUpperCase() + str.slice(1) + btoa(location.protocol);
        },


        async PostData(postcmd, jsondata) {
            // POST request using axios with error handling

            var Baseurl = location.protocol + "//" + location.hostname + "/xdt_restserver/";
            var Data64 = btoa(jsondata);
            var DataHash = this.$CryptoJS.SHA256(Data64);
            var Postdata = '{"Command":"' + postcmd + '","Data": "' + Data64 + '","Signature" : "' + DataHash + '","IRRToken": "' + localStorage.getItem('IIRToken') + '"}';
            var Headers = {
                //'Cache-Control': 'no-cache',
                "Content-Type": "application/json",

            };
            var RespJson = '';
            var RespJsonData = '';
            await axios
                .post(Baseurl, Postdata, { Headers })
                .then(
                    (response) => {
                        RespJson = JSON.parse(JSON.stringify(response.data));
                        RespJsonData = atob(RespJson.Data);
                        this.Signindialog = false;
                    }
                )
                .catch((error) => {
                    RespJsonData = 'ERROR';
                    switch (error.response.status) {
                        case 400:
                            this.$refs.confirm.open(
                                "Error",
                                error.request.statusText + " (" + error.response.status + ")" ,
                                "",
                                "Close",
                                { color: "error" }
                              );
                            break;
                        case 401:
                            this.$router.push('/Signin');
                            break;
                        case 403:
                            this.$refs.confirm.open(
                                "Error",
                                error.request.statusText + " (" + error.response.status + ")" ,
                                "",
                                "Close",
                                { color: "error" }
                              );
                            break;
                        case 404:
                            this.$refs.confirm.open(
                                "Error",
                                error.request.statusText + " (" + error.response.status + ")" ,
                                "",
                                "Close",
                                { color: "error" }
                              );
                            break;
                        case 500:
                            this.$refs.confirm.open(
                                "Error",
                                error.request.statusText + " (" + error.response.status + ")" ,
                                "",
                                "Close",
                                { color: "error" }
                              );
                            break;
                        default:
                    }
                });

            return (RespJsonData)
        },

        async Loadprofile() {

            this.myJsonResp = await this.PostData("LoadProfile", "");

            if (this.myJsonResp != "ERROR") {
                this.data = JSON.parse(this.myJsonResp);
                localStorage.setItem('CURPROFILE', this.data.DEFAULTPROFILE);
            }
        }



    }
})







